import { defineMessages } from 'react-intl';

export const eventMessages = defineMessages({
    entry: {
        id: 'entry',
        defaultMessage: 'Entry',
    },
    entryAttempt: {
        id: 'entry-attempt',
        defaultMessage: 'Entry attempt',
    },
    entrySuccess: {
        id: 'entry-success',
        defaultMessage: 'Entry success',
    },
    entryFailed: {
        id: 'entry-failed',
        defaultMessage: 'Entry failed',
    },
    exit: {
        id: 'exit',
        defaultMessage: 'Exit',
    },
    exitAttempt: {
        id: 'exit-attempt',
        defaultMessage: 'Exit attempt',
    },
    exitSuccess: {
        id: 'exit-success',
        defaultMessage: 'Exit success',
    },
    exitFailed: {
        id: 'exit-failed',
        defaultMessage: 'Exit failed',
    },
    extraEvents: {
        id: 'extra-events',
        defaultMessage: 'Extra events',
    },
    customer: {
        id: 'customer',
        defaultMessage: 'Customer',
    },
    message: {
        id: 'message',
        defaultMessage: 'Message',
    },
    pointName: {
        id: 'point-name',
        defaultMessage: 'Point name',
    },
    cardType: {
        id: 'card-type',
        defaultMessage: 'Card type',
    },
    cardTypeOperator: {
        id: 'card-type-operator',
        defaultMessage: 'Operator',
    },
    cardTypeNormal: {
        id: 'card-type-normal',
        defaultMessage: 'Normal',
    },
    cardTypeVIP: {
        id: 'card-type-vip',
        defaultMessage: 'VIP',
    },
    cardTypePrepaid: {
        id: 'card-type-prepaid',
        defaultMessage: 'Prepaid',
    },
    event: {
        id: 'event',
        defaultMessage: 'Event',
    },
    events: {
        id: 'events',
        defaultMessage: 'Events',
    },
    log: {
        id: 'log',
        defaultMessage: 'Log',
    },
    timestamp: {
        id: 'timestamp',
        defaultMessage: 'Timestamp',
    },
    category: {
        id: 'category',
        defaultMessage: 'Category',
    },
    filterByCategoryEvent: {
        id: 'filter-by-category-event',
        defaultMessage: 'Filter by category event',
    },
});
